import { ChangeEvent, FormEvent, FunctionComponent, useState } from 'react';

import { getErrorsFromRequest } from 'utils/api';

import { create as registerRequest } from 'requests/registerCompany';

import Button from 'components/layout/Button';
import { ButtonTypes } from 'components/layout/Button/types';
import Form from 'components/layout/forms/Form';
import Input from 'components/layout/forms/Input';
import InputRow from 'components/layout/forms/InputRow';

import StyledComponent from './styles';
import { Props } from './types';

interface HandleValue {
    [key:string]: string|number;
}

interface FormState {
    name: string;
    vatId: string;
    city: string;
    postCode: string;
    street: string;
    homeNo: string;
    flatNo: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
}

interface Errors extends FormState {};

const ContentSectionsCompanyRegisterForm: FunctionComponent<Props> = ({ translations, onSuccess }) => {
    const [formValues, setFormValues]: [FormState, Function] = useState(null);
    const [errorMessage, setErrorMessage]: [Errors, Function] = useState(null);

    const submitForm = (event:FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        registerRequest({ ...formValues })
            .then(() => onSuccess && onSuccess())
            .catch((errors) => setErrorMessage(getErrorsFromRequest(errors)));
    };

    const handleChange = (value: HandleValue) => setFormValues((prevState:FormState) => ({ ...prevState, ...value }));

    return (
        <StyledComponent className="content-section-company-register">
            <Form
                onSubmit={submitForm}
                className="register-form"
            >
                <h2 className="title">{translations?.titleCompany}</h2>
                <Input
                    name='name'
                    label={translations?.inputCompanyName}
                    placeholder={translations?.inputCompanyName}
                    onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ name: e.target.value })}
                    value={formValues?.name}
                    error={errorMessage?.name}
                />
                <Input
                    className='vat-id-input'
                    name='vatId'
                    label={translations?.inputVatId}
                    placeholder={translations?.inputVatId}
                    onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ vatId: e.target.value })}
                    value={formValues?.vatId}
                    error={errorMessage?.vatId}
                />
                <InputRow>
                    <Input
                        name='city'
                        label={translations?.inputCity}
                        placeholder={translations?.inputCity}
                        onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ city: e.target.value })}
                        value={formValues?.city}
                        error={errorMessage?.city}
                    />
                    <Input
                        name='postCode'
                        label={translations?.inputPostCode}
                        placeholder={translations?.inputPostCode}
                        onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ postCode: e.target.value })}
                        value={formValues?.postCode}
                        error={errorMessage?.postCode}
                    />
                </InputRow>
                <Input
                    name='street'
                    label={translations?.inputStreet}
                    placeholder={translations?.inputStreet}
                    onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ street: e.target.value })}
                    value={formValues?.street}
                    error={errorMessage?.street}
                />
                <InputRow>
                    <Input
                        name='homeNo'
                        label={translations?.inputHomeNo}
                        placeholder={translations?.inputHomeNo}
                        onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ homeNo: e.target.value })}
                        value={formValues?.homeNo}
                        error={errorMessage?.homeNo}
                    />
                    <Input
                        name='flatNo'
                        label={translations?.inputFlatNo}
                        placeholder={translations?.inputFlatNo}
                        onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ flatNo: e.target.value })}
                        value={formValues?.flatNo}
                        error={errorMessage?.flatNo}
                    />
                </InputRow>
                <h2 className="title title-margin">{translations?.titlePerson}</h2>
                <InputRow>
                    <Input
                        name='firstName'
                        label={translations?.inputFirstName}
                        placeholder={translations?.inputFirstName}
                        onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ firstName: e.target.value })}
                        value={formValues?.firstName}
                        error={errorMessage?.firstName}
                    />
                    <Input
                        name='lastName'
                        label={translations?.inputLastName}
                        placeholder={translations?.inputLastName}
                        onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ lastName: e.target.value })}
                        value={formValues?.lastName}
                        error={errorMessage?.lastName}
                    />
                </InputRow>
                <Input
                    name='email'
                    label={translations?.inputEmail}
                    placeholder={translations?.inputEmail}
                    onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ email: e.target.value })}
                    value={formValues?.email}
                    error={errorMessage?.email}
                />
                <Input
                    name='phone'
                    label={translations?.inputPhone}
                    placeholder={translations?.inputPhone}
                    onChange={(e:ChangeEvent<HTMLInputElement>) => handleChange({ phone: e.target.value })}
                    value={formValues?.phone}
                    error={errorMessage?.phone}
                />
                <Button
                    className="submit-button"
                    type={ButtonTypes.Submit}
                >
                    {translations?.submitButton}
                </Button>
            </Form>
        </StyledComponent>
    );
};

export default ContentSectionsCompanyRegisterForm;